import ContactForm from "../components/ContactForm";
import InnerBanner from "../presentation/InnerBanner";
import SEO from "../global/SEO";

const ContactUs = () => (
  <>
    <SEO 
      title="Contact LiveAssignment.com | Chat with Assignment Experts 24/7"
      description="Have questions? Connect with our team for assignment help, pricing, or queries. We're available 24/7 via chat, email, and WhatsApp."
      keywords="contact LiveAssignment, assignment help contact, 24/7 support, WhatsApp assignment help, customer service, assignment queries, pricing information"
      h1Heading="We're Here to Help – Get in Touch Anytime"
      canonicalUrl="https://liveassignment.com/contact-us"
    />
    <InnerBanner pageTitle="Contact Us"></InnerBanner>
    <ContactForm />
  </>
);

export default ContactUs;
